// extracted by mini-css-extract-plugin
export var button = "Header-module--button--2014e";
export var header = "Header-module--header--3c27c";
export var headerContainer = "Header-module--headerContainer--28a42";
export var icon = "Header-module--icon--acac5";
export var logoContainer = "Header-module--logoContainer--ca573";
export var logoDesktop = "Header-module--logoDesktop--12623";
export var logoMobile = "Header-module--logoMobile--0d931";